import { useContext } from 'react';
import { FixedSurfaceContext } from './FixedSurfaceContext';

export function useFixedSurface(): boolean {
  return useContext(FixedSurfaceContext);
}
